
/**
 * This is the base modal. It's simply a wrapper handling showing
 * and closing the modal. Any content to it is ported.
 */
import Vue from 'vue';

export default Vue.extend({
  name: 'o-BaseModal',
});
